export default __webpack_public_path__ + "static/media/thumb.02fefa80.png";